import { useNavigate } from 'react-router-dom';
import { BookOpen, ChevronRight, Crown, FileText } from 'lucide-react';
import { useTranslation } from '@parentpath/i18n';
import { useGuides } from '../hooks/useGuides';
import { useSubscription } from '@/features/subscription/hooks/useSubscription';

export function GlossarListPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('guides');
  const { data: guides, isLoading } = useGuides();
  const { isPremium } = useSubscription();

  return (
    <>
      {/* Header */}
      <h1 className="text-white text-xl font-semibold mb-6">{t('breadcrumbs.home')}</h1>

      {/* Breadcrumb */}
      <div className="flex items-center gap-2 text-white/80 text-sm mb-6">
        <BookOpen className="w-4 h-4" />
        <span>{t('breadcrumbs.glossary')}</span>
      </div>

      {/* Guide List */}
      {isLoading ? (
        <div className="space-y-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="glass-effect rounded-[15px] p-4 animate-pulse">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-white/10 rounded-xl"></div>
                <div className="flex-1">
                  <div className="h-5 bg-white/10 rounded w-1/3 mb-2"></div>
                  <div className="h-4 bg-white/10 rounded w-2/3"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="space-y-3">
          {guides?.map((guide) => {
            const isLocked = guide.is_premium && !isPremium;

            return (
              <button
                key={guide.id}
                onClick={() => {
                  if (isLocked) {
                    navigate('/subscription');
                  } else {
                    navigate(`/tools/guides/glossar/${guide.slug}`);
                  }
                }}
                className={`w-full glass-effect rounded-[15px] p-4 text-left transition-all ${
                  isLocked ? 'opacity-75' : 'hover:bg-white/10'
                }`}
              >
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                    <FileText className={`w-6 h-6 ${isLocked ? 'text-white/40' : 'text-pp-orange'}`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <h2 className="font-semibold text-white">
                        {guide.title}
                      </h2>
                      {guide.is_premium && (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-amber-500/20 text-amber-300 text-xs font-medium rounded-full">
                          <Crown className="w-3 h-3" />
                          {t('premium')}
                        </span>
                      )}
                    </div>
                    {guide.short_description && (
                      <p className="text-sm text-white/70 mt-0.5 truncate">
                        {guide.short_description}
                      </p>
                    )}
                  </div>
                  <ChevronRight className={`w-5 h-5 ${isLocked ? 'text-white/30' : 'text-pp-orange'}`} />
                </div>
              </button>
            );
          })}
        </div>
      )}
    </>
  );
}
